var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    width: 24,
    height: 24,
    rx: 2,
    fill: "#F4AC48"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0603 5.24667C11.3469 5.08507 11.6705 5 12 5C12.3295 5 12.6531 5.08507 12.9397 5.24667C13.2263 5.40825 13.4658 5.64076 13.6357 5.92131L13.6371 5.92353L19.7449 16.1362C19.9112 16.4249 19.9991 16.7518 20 17.0844C20.0009 17.4171 19.9149 17.7445 19.7501 18.034C19.5853 18.3236 19.3474 18.5655 19.0595 18.7351C18.7715 18.9048 18.4439 18.9963 18.1092 18.9999L18.1039 19L5.89083 19C5.55611 18.9963 5.22846 18.9048 4.94054 18.7351C4.65264 18.5655 4.41469 18.3236 4.24989 18.034C4.08511 17.7445 3.99908 17.4171 4.00001 17.0844C4.00094 16.7518 4.0888 16.4249 4.2552 16.1363L4.25893 16.1298L10.3629 5.92353L10.7677 6.16158L10.3643 5.92131C10.5342 5.64076 10.7737 5.40825 11.0603 5.24667ZM11.1717 6.40083L11.1711 6.40184L5.07059 16.6024C4.98638 16.7497 4.94166 16.9167 4.94118 17.087C4.9407 17.2585 4.98507 17.4269 5.06955 17.5753C5.15401 17.7237 5.27547 17.8468 5.42138 17.9328C5.56658 18.0184 5.73117 18.0644 5.89895 18.0666H18.1011C18.2688 18.0644 18.4334 18.0184 18.5786 17.9328C18.7245 17.8468 18.846 17.7237 18.9305 17.5753C19.0149 17.4269 19.0593 17.2585 19.0588 17.087C19.0583 16.9167 19.0136 16.7497 18.9294 16.6024L12.8289 6.40184L12.8283 6.40088C12.7413 6.2576 12.6193 6.13968 12.4745 6.058C12.3293 5.97615 12.1659 5.93333 12 5.93333C11.8341 5.93333 11.6707 5.97615 11.5255 6.058C11.3807 6.13967 11.2587 6.25758 11.1717 6.40083ZM12 8.5C12.2761 8.5 12.5 8.72386 12.5 9V13C12.5 13.2761 12.2761 13.5 12 13.5C11.7239 13.5 11.5 13.2761 11.5 13V9C11.5 8.72386 11.7239 8.5 12 8.5ZM12.5 15C12.5 14.7239 12.2761 14.5 12 14.5C11.7239 14.5 11.5 14.7239 11.5 15V16C11.5 16.2761 11.7239 16.5 12 16.5C12.2761 16.5 12.5 16.2761 12.5 16V15Z",
    fill: "#F4AC48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.3ada27df2ec443338ffeeaec7e202b32.svg";
export { ForwardRef as ReactComponent };